/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface SmsSuiviSearch
 */
export interface SmsSuiviSearch {
    /**
     * 
     * @type {number}
     * @memberof SmsSuiviSearch
     */
    idlot?: number;
    /**
     * 
     * @type {TextSearch}
     * @memberof SmsSuiviSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof SmsSuiviSearch
     */
    prenom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof SmsSuiviSearch
     */
    statut?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof SmsSuiviSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof SmsSuiviSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof SmsSuiviSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SmsSuiviSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof SmsSuiviSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof SmsSuiviSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the SmsSuiviSearch interface.
 */
export function instanceOfSmsSuiviSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SmsSuiviSearchFromJSON(json: any): SmsSuiviSearch {
    return SmsSuiviSearchFromJSONTyped(json, false);
}

export function SmsSuiviSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmsSuiviSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idlot': !exists(json, 'idlot') ? undefined : json['idlot'],
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'prenom': !exists(json, 'prenom') ? undefined : TextSearchFromJSON(json['prenom']),
        'statut': !exists(json, 'statut') ? undefined : TextSearchFromJSON(json['statut']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function SmsSuiviSearchToJSON(value?: SmsSuiviSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idlot': value.idlot,
        'nom': TextSearchToJSON(value.nom),
        'prenom': TextSearchToJSON(value.prenom),
        'statut': TextSearchToJSON(value.statut),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

